export const ErrorView = () => (
  <div className="flex flex-col items-center justify-center py-24 text-center">
    <span className="text-8xl font-bold text-rose-400">!</span>
    <h1 className="mt-4 text-2xl font-bold">Something went wrong</h1>
    <p className="mt-2 text-muted-foreground">
      An unexpected error occurred. Please try again.
    </p>
  </div>
)

export const ErrorFallback = () => (
  <div className="flex min-h-screen flex-col items-center justify-center bg-background">
    <ErrorView />
  </div>
)
